/**
 * A resized copy of an order photo, served by Next's image optimizer.
 *
 * Order photos are the customer's originals (3-6 MB each); a gallery of 100
 * of them on mobile data would download hundreds of megabytes to show tiles
 * the size of a thumbnail. Next fetches the original once on the server and
 * returns a small WebP/JPEG. Only the storage host allowed in next.config.js
 * (images.remotePatterns) can be resized; anything else -- a blob: preview, a
 * local dev host -- is returned as it is.
 *
 * `width` must be one of Next's configured sizes (imageSizes/deviceSizes):
 * 256 for tiles, 640 for the shop's product tiles (~256 CSS px on a 2-3x
 * screen), 1080 for the enlarged view. Quality stays at Next 16's only
 * default quality, 75.
 */
export const RESIZABLE_HOST = "a607181de81af75dce3bbf66fb345d00.eu.r2.cloudflarestorage.com";

export type PhotoWidth = 256 | 640 | 1080;

export function resizedPhotoUrl(url: string | undefined | null, width: PhotoWidth): string | undefined {
  if (!url) return undefined;
  let host: string;
  try {
    host = new URL(url).hostname;
  } catch {
    return url;
  }
  if (host !== RESIZABLE_HOST) return url;
  return `/_next/image?url=${encodeURIComponent(url)}&w=${width}&q=75`;
}
